import {ChangeDetectionStrategy, Component, inject, input, InputSignal, output, OutputEmitterRef} from "@angular/core";
import {GroupOrderModel} from '../../group-order/group-order.model';
import {PaymentType} from '../payment';
import {PaymentModel} from "../payment.model";
import {CardBrandComponent} from "../../ui-elements/card-brand/card-brand.component";
import {ApplePayButtonComponent} from '../wallet-payment/apple-pay-button/apple-pay-button.component';
import {GooglePayButtonComponent} from '../wallet-payment/google-pay-button/google-pay-button.component';
import {ButtonComponent} from '../../buttons/button/button.component';
import {PossessivePipe} from '../../utils/possessive.pipe';
import {ConfigurationModel} from '../../configuration/configuration.model';
import {OrderInitiationStatus, OrderModel} from "../../order/order.model";

@Component({
    selector: "woa-quick-pay-panel",
    templateUrl: "quick-pay-panel.component.html",
    styleUrl: "./quick-pay-panel.component.scss",
    imports: [
        ApplePayButtonComponent,
        ButtonComponent,
        CardBrandComponent,
        GooglePayButtonComponent,
        PossessivePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class QuickPayPanelComponent {
    public paymentModel: PaymentModel = inject(PaymentModel);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);
    public orderModel: OrderModel = inject(OrderModel);
    public groupOrderModel: GroupOrderModel = inject(GroupOrderModel);

    PaymentType = PaymentType;
    OrderInitiationStatus = OrderInitiationStatus;

    public readonly showSpinner: InputSignal<boolean> = input<boolean>(false);
    public readonly disabled: InputSignal<boolean> = input<boolean>(false);
    public readonly applePayType: InputSignal<"plain" | "check-out"> = input<"plain" | "check-out">("plain");
    public readonly googlePayType: InputSignal<"plain" | "checkout"> = input<"plain" | "checkout">("plain");

    public pay: OutputEmitterRef<PaymentType> = output<PaymentType>();
}
